// Liste complète des États (ISO 3166-1 alpha-2) → option { value, label } avec drapeau + nom français.
// Sert aux champs « pays de résidence » et « destination » du comparateur voyage : une résidence hors
// Schengen fait remonter automatiquement les produits visa Schengen côté back.

const COUNTRY_CODES = [
    "AD", "AE", "AF", "AG", "AL", "AM", "AO", "AR", "AT", "AU", "AZ", "BA", "BB", "BD", "BE", "BF",
    "BG", "BH", "BI", "BJ", "BN", "BO", "BR", "BS", "BT", "BW", "BY", "BZ", "CA", "CD", "CF", "CG",
    "CH", "CI", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO",
    "DZ", "EC", "EE", "EG", "ER", "ES", "ET", "FI", "FJ", "FR", "GA", "GB", "GD", "GE", "GH", "GM",
    "GN", "GQ", "GR", "GT", "GW", "GY", "HK", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IN", "IQ", "IR",
    "IS", "IT", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KZ", "LA",
    "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MG", "MH",
    "MK", "ML", "MM", "MN", "MR", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NE", "NG", "NI",
    "NL", "NO", "NP", "NZ", "OM", "PA", "PE", "PG", "PH", "PK", "PL", "PT", "PW", "PY", "QA", "RO",
    "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SI", "SK", "SL", "SM", "SN", "SO", "SR",
    "SS", "ST", "SV", "SY", "SZ", "TD", "TG", "TH", "TJ", "TL", "TM", "TN", "TO", "TR", "TT", "TV",
    "TW", "TZ", "UA", "UG", "US", "UY", "UZ", "VA", "VC", "VE", "VN", "VU", "WS", "YE", "ZA", "ZM",
    "ZW",
]

// Territoires français d'outre-mer (DROM + COM), absents de la liste des États. Proposés en destination
// uniquement : les six partenaires les tarifent (zonage propre à chacun), mais en résidence le back
// les traiterait comme hors Schengen et ne remonterait que les produits visa Schengen.
const FRENCH_OVERSEAS_CODES = ["GP", "MQ", "GF", "RE", "YT", "PM", "BL", "MF", "WF", "PF", "NC"]

const regionNames = new Intl.DisplayNames(["fr"], { type: "region" })

// Intl rend « R.A.S. chinoise de Hong Kong », trop administratif pour une liste de destinations.
const COUNTRY_NAME_OVERRIDES: Record<string, string> = { HK: "Hong Kong" }

const flag = (code: string): string =>
    String.fromCodePoint(...code.split("").map((char) => 0x1f1e6 + char.charCodeAt(0) - 65))

const toCountryOptions = (codes: string[]) =>
    codes
        .map((code) => ({ value: code, name: COUNTRY_NAME_OVERRIDES[code] ?? regionNames.of(code) ?? code }))
        .sort((a, b) => a.name.localeCompare(b.name, "fr"))
        .map(({ value, name }) => ({ value, label: `${flag(value)} ${name}` }))

export const COUNTRY_OPTIONS = toCountryOptions(COUNTRY_CODES)
export const DESTINATION_COUNTRY_OPTIONS = toCountryOptions([...COUNTRY_CODES, ...FRENCH_OVERSEAS_CODES])

export const countryLabel = (code: string): string =>
    DESTINATION_COUNTRY_OPTIONS.find((option) => option.value === code)?.label.replace(/^\S+\s/, "") ?? code

// Pays non assurables (sanctions/conflit) : aucun assureur voyage FR ne les couvre → hors destination.
export const TRAVEL_DESTINATION_BLOCKLIST = ["KP", "IR", "SY", "RU", "BY", "AF", "SD", "SS", "YE", "LY"]
